export const getContactsListQueryKeys = (params) => ({
  contactsList: ["contacts_list", { ...params }],
  inboxLeadsList: ["inbox_leads_list", { ...params }],
});

export const getInboxNotificationsCountQueryKeys = {
  notificationsCount: ["notifications_count"],
};
